<template>
    <div class="user-list">
        <!--<el-form :inline="true" class="demo-form-inline" v-loading="loading" size="mini">-->
            <!--<el-form-item>-->
                <!--<el-input v-model="search" placeholder="输入名字查询" size="small"></el-input>-->
            <!--</el-form-item>-->
            <!--<el-form-item>-->
                <!--<el-button-group>-->
                    <!--<el-button type="primary" @click="fetch" size="mini">查询</el-button>-->
                    <!--<el-button @click="add" size="mini">增加</el-button>-->

                <!--</el-button-group>-->
            <!--</el-form-item>-->
        <!--</el-form>-->

        <h3>需求管理</h3>
        <el-table :data="list" size="mini">
            <!--<el-table-column type="expand">-->
                <!--<template slot-scope="props">-->
                   <!--dsds-->
                <!--</template>-->
            <!--</el-table-column>-->
            <el-table-column prop="needsId" label="ID"></el-table-column>
            <el-table-column prop="tip" label="状态"></el-table-column>
            <el-table-column prop="userAName" label="甲方"></el-table-column>
            <el-table-column prop="userBName" label="乙方"></el-table-column>
            <el-table-column prop="amount" label="报价"></el-table-column>
            <el-table-column prop="amountFinal" label="最终报价"></el-table-column>
        </el-table>
        <br/>
        <div style="float: right">
            <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="i=>page=i"
                    :page-size="20"
                    :page-count="page"
                    :total="total">
            </el-pagination>
        </div>

    </div>
</template>

<script>

  import api from '../api'
  const {need} = api



  export default {
    name: "user-list",
    data() {
      return {
        loading: true,
        search: "",
        list: [],
        roles:[],
        total:0,
        page:1
      };
    },
    watch:{
      page(){
        this.fetch()
      }
    },
    methods: {

      async fetch() {
        let pageNum = this.page
        this.loading = true;

        let res = await need.list({start:(pageNum-1)*20},{header:{token:1}});
        this.list = res.data.data;
        this.loading = false;
        this.total = res.data.pageinfo.totalCount
      }
    },
    mounted() {
      this.fetch();
    }
  };
</script>

<style>
    .user-list {
    }
</style>



// WEBPACK FOOTER //
// src/views/order/need.vue